






















import Vue from 'vue'

export default Vue.extend({
	data() {
		return {
			filter: '',
			faqs: <Array<{question: string, html: string, keywords: string}>> [
				{
					question: 'Wie kann ich mein Profil bearbeiten?',
					// eslint-disable-next-line max-len
					html: 'Klicken Sie auf <a href="/profile/">Ihrem Profil</a> das Zahnrad-Symbol an. Anschließend öffnet sich ein Dialogfenster, in dem Sie Ihr Profil und Ihre Einstellungen verwalten können.',
					keywords: 'profil einstellungen bearbeiten profilbild persönliche informationen',
				},
				{
					question: 'Ich habe meine Registrierungs-E-Mail nicht erhalten.',
					// eslint-disable-next-line max-len
					html: 'Nach der Registrierung können Sie Ihr Konto für 48 Stunden ohne Bestätigung der E-Mail-Adresse nutzen. Nach diesem Zeitraum wird Ihr Account vorrübergehend deaktiviert, bis Sie Ihre E-Mail-Adresse bestätigt haben.<br />In manchen Fällen ist die Zustellung der E-Mail verzögert. Wenn Ihr Konto deaktiviert wurde, haben Sie beim Login die Möglichkeit diese Bestätigungs-E-Mail <b>erneut anzufordern</b>. Bitte überprüfen Sie hierbei auch Ihren Spam-Ordner. Sollten Sie die E-Mails weiterhin nicht erhalten, können Sie uns <a href="/support">hier</a> kontaktieren.',
					keywords: 'account aktivierung deaktiviert konto registrierung nicht erhalten',
				},
				{
					question: 'Ich kann meinen Beitrag nicht löschen.',
					// eslint-disable-next-line max-len
					html: 'Um die Unterbrechung von Diskussionen/Konversationen unter Beiträgen zu vermeiden, ist es nur möglich neue Beiträge <b>ohne Kommentare</b> zu löschen. Sie haben allerdings jederzeit die Möglichkeit diesen Beitrag zu <b>bearbeiten</b>, falls Sie Inhalte aus Ihrem Beitrag entfernen möchten. Falls Ihr Beitrag unerwünschte Kommentare, die gegen unsere Nutzungsbedingungen verstoßen, enthält, können Sie diese Kommentare direkt melden. Diese werden anschließend von uns geprüft und ggf. entfernt. In dringenden Fällen können Sie auch den <a href="/support/">Support</a> kontaktieren, damit wir uns schnellstmöglich um Ihr Anliegen kümmern können.',
					keywords: 'beitrag löschen entfernen',
				},
				{
					question: 'Wie kann ich mein Konto löschen?',
					// eslint-disable-next-line max-len
					html: 'Sie können Ihr WithIn-Konto jederzeit unter über Ihr <a href="/profile/">Profil</a> löschen. Klicken Sie dort auf das Einstellungs-Symbol (Zahnrad), wählen Sie im Popup den Reiter <b>Einstellungen</b> und klicken Sie auf die Schaltfläche <b>Account löschen</b>.',
					keywords: 'konto account löschen deaktivieren',
				},
			],
		}
	},
	head() {
		return {
			title: 'FAQ | WithIn',
		}
	},
	computed: {
		matchingFaqs(): Array<any> {
			const { faqs } = this

			if (!this.filter.length) {
				return faqs
			}

			const searchKeywords = this.filter.split(' ')

			return faqs.filter((faq: any) => (
				searchKeywords.filter((word: any) => (
					faq.keywords.includes(word.toLowerCase())
					|| faq.question.toLowerCase().includes(word.toLowerCase())
				))
			).length === searchKeywords.length)
		},
	},
})
